import { render } from "./SVGTextBox.vue?vue&type=template&id=3400d8a7&scoped=true"
import script from "./SVGTextBox.vue?vue&type=script&lang=ts"
export * from "./SVGTextBox.vue?vue&type=script&lang=ts"

import "./SVGTextBox.vue?vue&type=style&index=0&id=3400d8a7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3400d8a7"

export default script